import React from 'react';
import styled from 'styled-components';
import swal from 'sweetalert';
import NProgress from 'nprogress';

import zip from '../../svg/zip.svg';
import pdf from '../../svg/pdf.svg';
import MonthMenu from './MonthMenu';
import PdfService from '../../services/PdfService';
import { AnalyticsService } from '../../services/AnalyticsService';
import { report as api } from '../../services/api';
import logo from '../../svg/nc-logo.svg';
import { APP_URL } from '../../services/constants';
import { redirectToDownloadUrl } from '../../helpers';

NProgress.configure({ trickleSpeed: 150 });

const PdfButton = styled.div`
  padding-left: 15px;
  width: 233px;
  height: 60px;
  padding-top: 17px;
  cursor: pointer;
  display: inline-block;
  background-color: #fafafa;
  margin-top: 17px;
  margin-left: 20px;
  @media print {
    display: none !important;
  }
`;

const ZipButton = styled(PdfButton)`
  width: 250px;
`;

const BrandName = styled.div`
  font-family: BrandonGrotesque-Medium;
  padding-top: 10px;
  font-size: 30px;
  font-weight: 500;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  color: #333333;
`;

const BrandSubtitle = styled.div`
  padding-top: 10px;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 3px;
  color: #999999;
`;

const HeaderSubtitle = styled.div`
  display: inline;
  margin-right: 30px;
  font-family: BrandonGrotesque-Medium;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 3px;
  color: var(--color-gunmetal);
  margin-right: ${(props) => (props.from ? '30px' : '0px')};
`;

const ButtonText = styled.div`
  display: inline-block;
  font-family: BrandonGrotesque-Medium;
  padding-left: 20px;
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 3px;
  color: #555555;
`;

interface Props {
  dates?: MonthlyReportDate;
  report: any;
  big: boolean;
  subtitle?: string;
  loadDate?: Function;
  range: string;
}

class ReportHeader extends React.Component<Props, {}> {
  downloadPdf() {
    let data;

    const { dates, report } = this.props;

    if (report.type === 'monthly' && dates) {
      const month = dates.month > 9 ? dates.month : '0' + dates.month;

      data = {
        filename: `${this.props.report.title} - NC Results - ${month}${dates.year % 100}.pdf`,
        localStorage: {
          pdf_render_month: dates.month,
          pdf_render_year: dates.year,
        },
      };
    } else if (report.type === 'offer') {
      data = {
        id: this.props.report.id,
        filename: `${this.props.report.title} -  NC Results.pdf`,
      };
    } else {
      data = {
        filename: `${this.props.report.title} - NC Results.pdf`,
      };
    }

    if (this.props.report.show_pricing !== 'none') {
      data.appendPricing = this.props.report.show_pricing;
    }

    data.orienntation = 'landscape';
    data.destination = this.props.big ? 'email' : 'link';

    data.reportId = report.id;

    NProgress.start();
    AnalyticsService.track('Download report PDF', { name: data.finalName });

    const url =
      report.type === 'monthly' ? `${APP_URL}/results` : `${APP_URL}/static/${data.reportId}`;

    PdfService.generate(url, data)
      .then((result: any) => {
        if (result.url === null && result.mail === true) {
          swal(
            'Report is over 25MB - compressed version will be emailed to partnerships@neoncoat.com when completed.'
          );

          NProgress.done();
        } else if (result.url) {
          redirectToDownloadUrl(result.url, 'report.pdf');

          NProgress.done();
        } else {
          NProgress.done();

          swal('An error occured while generating the report!', 'Please try again', 'error');
        }
      })
      .catch((error) => {
        NProgress.done();

        swal('An error occured while generating the report!', 'Please try again', 'error');
      });
  }

  downloadContent() {
    const { dates } = this.props;

    if (dates) {
      api
        .signContentDownload(dates.month > 9 ? dates.month : '0' + dates.month, dates.year)
        .then((data: any) => {
          redirectToDownloadUrl(data, 'report.pdf', true);
        });
    } else {
      redirectToDownloadUrl(api.downloadZip(this.props.report.id), 'report.pdf', true);
    }
  }

  render() {
    return (
      <div className="row" style={{ fontFamily: 'BrandonGrotesque-Regular', marginBottom: '0px' }}>
        <div
          style={{
            display: 'inline-block',
            marginLeft: '20px',
            marginRight: '48px',
            marginTop: '-10px',
          }}
        >
          <img src={logo} style={{ padding: '16px 0px' }} alt="Neon Coat Logo" />
        </div>
        <div style={{ display: 'inline-block', marginTop: '-10px' }}>
          <BrandName>{this.props.report.title.toUpperCase()}</BrandName>
          <BrandSubtitle>{this.props.subtitle || 'ORGANIC RESULTS.'}</BrandSubtitle>
          {!this.props.dates ? (
            <HeaderSubtitle from={true}>
              {this.props.range ? this.props.range : null}
            </HeaderSubtitle>
          ) : (
            <MonthMenu dates={this.props.dates} loadDate={this.props.loadDate} />
          )}

          <PdfButton onClick={() => this.downloadPdf()}>
            <img src={pdf} alt="Download PDF" />
            <ButtonText>Download PDF</ButtonText>
          </PdfButton>
          {true && (
            <ZipButton onClick={() => this.downloadContent()}>
              <img src={zip} alt="Download content" />
              <ButtonText>Download Content</ButtonText>
            </ZipButton>
          )}
        </div>
      </div>
    );
  }
}

export default ReportHeader;
